<script lang="ts">
  import {Col, Image, Card } from "sveltestrap";
  import Link from "svelte-link";
  import { href} from "../../../utils/Constant/Constant";
  import {Bookmarkcartdata} from "../../../Data/Bookmarks/BookmarkDetails"
  import {bookmarkItem,newBookmarkAdd} from "../../../store"
  import NewBookmarkModal from "./NewBookmarkModal.svelte";
  import BookmarkHoverBlock from "./BookmarkHoverBlock.svelte";
    let imgPath:string = "/assets/images/lightgallry" 
    type filterdata= {
        img: string;
        id: string;
        header: string;
        fillstar: boolean;
        link: string;
        content: string;
        title: string;
        class: string;
        class2: string;
    }[]
    let setNewBookmarkAdd:filterdata
    newBookmarkAdd.subscribe((value)=>{
        setNewBookmarkAdd = value
    })
    newBookmarkAdd.update(value => value = Bookmarkcartdata)
    const selectItem = (selectvalue:any) =>{
        if(selectvalue.fillstar === false){
            selectvalue.fillstar = true
        }else{
            selectvalue.fillstar = false
        }
        bookmarkItem.update(value => [...value,selectvalue])
    }
</script>
{#each setNewBookmarkAdd as bookmarkItem}
    <Col xl="3" lg="6" md="4" sm="6" class="xl-50 box-col-6">
        <Card class="bookmark-card o-hidden">
            <div class="details-website">
                <Image fluid src="{imgPath}/{bookmarkItem.img}" alt="" />
                <div class="favourite-icon {bookmarkItem.class2} {bookmarkItem.fillstar ? "favourite" : ""}" >
                    <Link href={href} on:click={()=>selectItem(bookmarkItem)}>
                        <i class="fa fa-star"></i>
                    </Link> 
                </div>
                <div class="desciption-data">
                    <BookmarkHoverBlock bookmarkItem={bookmarkItem} />
                </div>
            </div>
        </Card>
    </Col>
{/each}
<NewBookmarkModal/>
